export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSkladov';
export const NAME = 'Skladov';
